import { Link } from 'react-router-dom';
import {  Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';
import { useTranslation} from '../../TranslationContext';

export const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: t('home'), path: '/' },
    { name: t('about'), path: '/about' },
    { name: t('products'), path: '/' },
    { name: t('become_client'), path: '/BecomeClient' },
    { name: t('faq'), path: '/faq' },
    { name: t('contact_us'), path: '/Contact' }
  ];

  const services = [
    { name: t('authentication'), path: '/services/authentication' },
    { name: t('app_development'), path: '/services/app-development' },
    { name: t('security_consulting'), path: '/services/security-consulting' },
    { name: t('user_training'), path: '/services/user-training' },
    { name: t('maintenance'), path: '/services/maintenance' }
  ];

  const socialLinks = [
    { Icon: Facebook, href: 'https://facebook.com/ottenti', label: 'Facebook' },
    { Icon: Twitter, href: 'https://twitter.com/ottenti', label: 'Twitter' },
    { Icon: Linkedin, href: 'https://linkedin.com/company/ottenti', label: 'LinkedIn' },
    { Icon: Instagram, href: 'https://instagram.com/ottenti', label: 'Instagram' }
  ];

  return (
    <footer className="bg-white dark:bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo et description */}
          <div className="col-span-1">
            <Link to="/" className="flex items-center">
            <img src="/logoOtentiNew.png" alt="Logo" className="h-9 w-9 sm:h-11 sm:w-11" />
              <span className="ml-2 text-2xl font-bold text-gray-900 dark:text-white">
                {t('app_name')}
              </span>
            </Link>
            <p className="mt-4 text-gray-600 dark:text-gray-300">
              {t('footer_description')}
            </p>
          </div>

          {/* Liens rapides */}
          <div className="col-span-1">
            <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider">
              {t('quick_links')}
            </h3>
            <ul className="mt-4 space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-600 hover:text-indigo-600 dark:text-gray-300 dark:hover:text-indigo-400"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="col-span-1">
            <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider">
              {t('our_services')}
            </h3>
            <ul className="mt-4 space-y-2">
              {services.map((service) => (
                <li key={service.name}>
                  <Link
                    to={service.path}
                    className="text-gray-600 hover:text-indigo-600 dark:text-gray-300 dark:hover:text-indigo-400"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="col-span-1">
            <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider">
              {t('contact')}
            </h3>
            <ul className="mt-4 space-y-2">
              <li>
                <a 
                  href="mailto:contact@ottenti.com" 
                  className="flex items-center text-gray-600 dark:text-gray-300 hover:text-indigo-600 dark:hover:text-indigo-400"
                >
                  <Mail className="h-5 w-5 mr-2" />
                  contact@otenti.com
                </a>
              </li>
              <li>
                <a 
                  href="tel:+33xxxxxx" 
                  className="flex items-center text-gray-600 dark:text-gray-300 hover:text-indigo-600 dark:hover:text-indigo-400"
                >
                  <Phone className="h-5 w-5 mr-2" />
                  +33 xx xx xx
                </a>
              </li>
              <li className="flex items-center text-gray-600 dark:text-gray-300">
                <MapPin className="h-5 w-5 mr-2" />
                {t('location')}
              </li>
            </ul>
          </div>
        </div>

        {/* Réseaux sociaux */}
        <div className="mt-8 border-t border-gray-200 dark:border-gray-700 pt-8">
          <div className="flex justify-center space-x-6">
            {socialLinks.map(({ Icon, href, label }) => (
              <a
                key={label}
                href={href}
                className="text-gray-400 hover:text-indigo-600 dark:hover:text-indigo-400"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
              >
                <Icon className="h-6 w-6" />
              </a>
            ))}
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 text-center text-gray-500 dark:text-gray-400 text-sm">
          <p>© {currentYear} {t('app_name')}. {t('all_rights_reserved')}, African branch of NebaïX (Belgium).</p>
        </div>
      </div>
    </footer>
  );
};



<p className="text-center text-xs mt-2 text-gray-500 dark:text-gray-400">

</p>

export default Footer;
